import { VectorSquareMinusIcon } from './VectorSquareMinusIcon';

/**
 * author: Andrea Antonello
 * id 5B415AB4-7F0B-458F-8CB5-CA456D6A48A5
 * name vector-square-minus
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vector-square-minus.svg
 * tags
 * - Vector 
 */
export const VectorSquareSubtractIcon = VectorSquareMinusIcon;
export default VectorSquareSubtractIcon